import helper from './helper'
import axiosHandler from './vendor/axios'
import { nexus } from './transport/nexus'
import { channels } from './transport/channels'

export default {
  install (Vue, {axios, store, pusher}) {
    this.axios = axios
    this.nexus = nexus
    this.channels = channels

    Vue.url = helper.url()

    // Give axios to nexus, so he can make http request
    this.nexus.init({axios})

    // Sync tokens between nexus and axios
    axiosHandler.sync({axios, nexus})

    // Attaching stores to our channel
    this.channels.init({nexus, store, pusher})
    this.channels.connect()

    Vue.prototype.$nexus = this
    Vue.prototype.$channels = channels
  },
  login (email, password) {
    return this.nexus.authenticate(email, password)
  },
  logout () {
    this.nexus.forgetToken()
    this.channels.disconnect()
    return Promise.resolve()
  },
  getToken () {
    return this.nexus.getToken()
  },
  hasToken () {
    return this.nexus.hasToken()
  },
  on (event, method) {
    return this.nexus.on(event, method)
  },
  get (endpoint, url, config) {
    return this.axios.get(helper.url(endpoint, url), config)
  },
  delete (endpoint, url, config) {
    return this.axios.delete(helper.url(endpoint, url), config)
  },
  post (endpoint, url, data, config) {
    return this.axios.post(helper.url(endpoint, url), data, config)
  },
  put (endpoint, url, data, config) {
    return this.axios.put(helper.url(endpoint, url), data, config)
  },
  patch (endpoint, url, data, config) {
    return this.axios.patch(helper.url(endpoint, url), data, config)
  },
  nexus,
  channels
}



//////////////////
// WEBPACK FOOTER
// ./libs/@db2b/nexus-js-v1/index.js
// module id = 212
// module chunks = 1